import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { Patient } from "./schema";
import { pharmacyClient } from "@/connect";
import { ListPatientsResponse } from "@/gen/patients/list_patients_pb";

const API_URL = import.meta.env.VITE_API_URL as string;

export const getPatients = async (page: number, pageSize: number, search: string = ''): Promise<ListPatientsResponse> => {
    
        return await pharmacyClient.listPatients({
                page,
                pageSize,
                searchQuery: search,
    });
};
